export const enum Chars {
  Bell = '\x07',
  Newline = '\x0a',
  Tab = '\x09',
  Space = ' ',
  Ellipsis = '…',
}

export const enum Box {
  TopLeft = '┌',
  TopRight = '┐',
  BottomLeft = '└',
  BottomRight = '┘',
  Vertical = '│',
  VerticalRight = '├',
  VerticalLeft = '┤',
  Horizontal = '─',
  HorizontalDown = '┬',
  HorizontalUp = '┴',
  Cross = '┼',
}

export const enum HeavyBox {
  TopLeft = '┏',
  TopRight = '┓',
  BottomLeft = '┗',
  BottomRight = '┛',
  Vertical = '┃',
  VerticalRight = '┣',
  VerticalLeft = '┫',
  Horizontal = '━',
  HorizontalDown = '┳',
  HorizontalUp = '┻',
  Cross = '╋',
}

export const enum DoubleBox {
  TopLeft = '╔',
  TopRight = '╗',
  BottomLeft = '╚',
  BottomRight = '╝',
  Vertical = '║',
  VerticalRight = '╠',
  VerticalLeft = '╣',
  Horizontal = '═',
  HorizontalDown = '╦',
  HorizontalUp = '╩',
  Cross = '╬',
}

export enum RoundedBox {
  TopLeft = '╭',
  TopRight = '╮',
  BottomLeft = '╰',
  BottomRight = '╯',
  Vertical = '│',
  VerticalRight = '├',
  VerticalLeft = '┤',
  Horizontal = '─',
  HorizontalDown = '┬',
  HorizontalUp = '┴',
  Cross = '┼',
}

export const enum Arrow {
  Right = '→',
  Left = '←',
  Up = '↑',
  Down = '↓',
  LeftRight = '↔',
  UpDown = '↕',
}

export const enum Triangle {
  Right = '▶',
  Left = '◀',
  Up = '▲',
  Down = '▼',
}

export const enum SmallTriangle {
  Right = '▸',
  Left = '◂',
  Up = '▴',
  Down = '▾',
}

export const enum Line {
  DiagonalCross = '╳',
  Diagonalbackwards = '╲',
  Diagonal = '╱',
  VerticalDashed = '┆',
  VerticalDashedHeavy = '┇',
  Vertical = '│',
  VerticalHeavy = '┃',
  HorizontalDashed = '┄',
  HorizontalDashedHeavy = '┅',
  Horizontal = '─',
  HorizontalHeavy = '━',
}

export const enum Circle {
  Filled = '●',
  Outline = '◯',
  OutlineFilled = '◉',
  Dotted = '◌',
  Doubled = '◎',
  Small = '•',
  HalfLeft = '◐',
  HalfTop = '◓',
  HalfRight = '◑',
  HalfBottom = '◒',
}

export const enum Chevron {
  Default = '',
  Small = '›',
  Heavy = '❯',
}

export const enum Diamond {
  Default = '◆',
  Outline = '◇',
}

export const enum Square {
  Default = '■',
  Outline = '☐',
  Crossed = '☒',
}

export const enum Heart {
  Default = '❤︎',
  Outline = '♥',
}

export const enum Icons {
  Tick = '✓',
  TickSwoosh = '✔',
  Cross = '✖',
  CrossSwoosh = '✘',
  Home = '⌂',
  Note = '♪',
  Warning = '⚠',
  Info = 'ℹ',
  Star = '★',
}

export const enum Shade {
  Light = '░',
  Medium = '▒',
  Heavy = '▓',
}

export const dotSpinner = ['⠋', '⠙', '⠹', '⠸', '⠼', '⠴', '⠦', '⠧', '⠇', '⠏'];
export const circleSpinner = ['◐', '◓', '◑', '◒'];
